// extracted by mini-css-extract-plugin
module.exports = {"platformTab":"PlatformTab-module--platformTab--1zQ0C","fadeIn":"PlatformTab-module--fadeIn--3I151"};